export default __webpack_public_path__ + "static/media/EN_06.05c54226.svg";